import { render } from "./ContatoForm.vue?vue&type=template&id=e8deab86"
import script from "./ContatoForm.vue?vue&type=script&lang=js"
export * from "./ContatoForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__